import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/homeData';

const toneStyles: Record<string, { icon: string; line: string; hover: string }> = {
  primary: {
    icon: 'bg-primary-100 text-primary-700',
    line: 'bg-primary-500',
    hover: 'group-hover:text-primary-600',
  },
  accent: {
    icon: 'bg-accent-100 text-accent-700',
    line: 'bg-accent-500',
    hover: 'group-hover:text-accent-700',
  },
  secondary: {
    icon: 'bg-secondary-100 text-secondary-700',
    line: 'bg-secondary-500',
    hover: 'group-hover:text-secondary-700',
  },
};

export default function CategoriesSection() {
  return (
    <section id="categories" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="TOPIC INDEX"
          title="六大主题，把离奇世界分门别类"
          desc="从街头的奇闻现场，到夜深人静时的都市怪谈，每一条内容都能找到它该待的位置。"
        />

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-foreground-950/10 bg-foreground-950/10 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const tone = toneStyles[cat.tone] ?? toneStyles.primary;
            return (
              <a
                key={cat.slug}
                href="#latest"
                className="group flex flex-col bg-background-50 p-6 transition-colors hover:bg-background-100 md:p-8"
              >
                <div className="flex items-start justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-md text-2xl ${tone.icon}`}>
                    <i className={cat.icon}></i>
                  </span>
                  <span className="font-heading text-3xl font-black text-foreground-950/10 transition-colors group-hover:text-foreground-950/20">
                    {String(cat.count).padStart(3, '0')}
                  </span>
                </div>
                <h3 className={`mt-6 font-heading text-lg font-bold text-foreground-950 transition-colors ${tone.hover}`}>
                  {cat.name}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{cat.desc}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-xs font-medium text-foreground-500 transition-colors group-hover:text-foreground-900">
                  <span className={`h-px w-5 ${tone.line} transition-all group-hover:w-9`} />
                  收录 {cat.count} 篇
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}